<script lang="ts">
	import { Icon } from '@repo/commons/components'
	import { fadeHeight } from '@repo/commons/utils'

	interface Props {
		title: string
		isCollapsable?: boolean
		defaultOpen?: boolean
		elevation?: boolean
		class?: string
		children?: any
	}

	let {
		title,
		defaultOpen = true,
		isCollapsable = true,
		elevation = true,
		class: className = '',
		children
	}: Props = $props()
	let open = $state(defaultOpen)

	const toggle = () => {
		if (!isCollapsable) {
			return
		}
		open = !open
	}
</script>

<div class="card-container {className}" class:elevation>
	<button class="card-header" class:card-header-inactive={!isCollapsable} onclick={toggle}>
		<span>{title}</span>
		{#if isCollapsable}
			<Icon name="chevronDown" class={`expandable-card-chevron ${open ? 'expanded' : ''}`} />
		{/if}
	</button>

	{#if open}
		<div class="card-content-wrapper" transition:fadeHeight={{ duration: 50 }}>
			{@render children?.()}
		</div>
	{/if}
</div>

<style>
	.card-container {
		@apply bg-white border border-[#003A661A] rounded-xl flex flex-col;

		&.elevation {
			@apply shadow-md;
		}
	}
	.card-header {
		@apply w-full flex justify-between items-center p-6 flex-shrink-0 text-left;

		span {
			@apply text-xl text-[#001626E5] font-semibold;
		}
	}
	.card-header-inactive {
		@apply cursor-default;
	}
	.card-content-wrapper {
		@apply px-2 pb-6 flex-1 min-h-0 flex flex-col;
	}
	:global(.expandable-card-chevron) {
		transition: transform 0.3s;
		&.expanded {
			transform: rotate(180deg);
		}
	}
</style>
